export const PAY_URL = ['/Invest/Invest_Pledge/orderCreate', '/Invest/Invest_Pledge/getCoin']
export const NETWORK_WAIT = 500
